// import React from "react";
// import "./PizzaLoader.css"; // we'll create this CSS file

// const PizzaLoader = () => {
//   return (
//     <div className="pizza-loader">
//       <div className="pizza">
//         <div className="slice slice1"></div>
//         <div className="slice slice2"></div>
//         <div className="slice slice3"></div>
//         <div className="slice slice4"></div>
//         <div className="slice slice5"></div>
//         <div className="slice slice6"></div>
//       </div>
//       <p>Baking your data…</p>
//     </div>
//   );
// };

// export default PizzaLoader;

import React from "react";
import "./PizzaLoader.css";

export default function PizzaLoader({
  size = 96, // px
  speedSec = 1.2, // spin duration
  pepperoni = 6, // how many toppings
  label = "Loading…", // accessibility text
}) {
  const tops = Array.from({ length: pepperoni });
  return (
    <div
      className="pizza-loader"
      role="status"
      aria-label={label}
      title={label}
      style={{ "--size": `${size}px`, "--speed": `${speedSec}s` }}
    >
      <div className="pizza">
        {/* slice dividers */}
        {Array.from({ length: 8 }).map((_, i) => (
          <span key={i} className="slice" style={{ "--rot": `${i * 45}deg` }} />
        ))}

        {/* pepperoni (auto–spread & bounce) */}
        <div className="toppings">
          {tops.map((_, i) => (
            <span
              key={i}
              className="pep"
              style={{
                "--idx": i,
                // distribute in a ring with slight randomness for charm
                "--angle": `${(i / pepperoni) * 360}deg`,
                "--radius": "28%", // distance from center
                "--delay": `${(i * 0.1) % 0.6}s`,
              }}
            />
          ))}
        </div>
      </div>
      <p className="pizza-label">{label}</p>
      <p>Processing... Please wait.</p>
    </div>
  );
}
